<template>
  <div v-show="modalManager.state.visibleMap.c" class="guide-overlay" @touchmove.prevent>
    <!-- 蒙层 -->
    <div class="overlay" @touchmove.prevent></div>

    <!-- 高亮模块复制 -->
    <div
      v-if="currentStep"
      class="highlight-clone"
      :style="highlightStyle"
      ref="cloneContainer"
    ></div>

    <!-- 防点击透明层 -->
    <div
      v-if="currentStep"
      class="transparent-layer"
      :style="highlightStyle"
      @click="nextStep"
    ></div>

    <!-- 指引 -->
    <div class="guide-text" :style="textStyle">
      <div class="step1-tips" v-if="currentStepIndex === 0">
        <img src="../../assets/v2/guide/step1.png" />
        <button @click="nextStep">下一步</button>
      </div>
      <div class="step2-tips" v-if="currentStepIndex === 1">
        <img src="../../assets/v2/guide/step2.png" />
        <button @click="nextStep">知道啦</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import modalManager from '@/utils/modalManager'

export default {
  data() {
    return {
      steps: [{ selector: '#step1' }, { selector: '#step2' }],
      currentStepIndex: 0,
      highlightStyle: {}, // 高亮模块样式
      textStyle: {}, // 文本指引样式
      buttonStyle: {},
    }
  },
  computed: {
    modalManager() {
      return modalManager;
    },
    visibleMap() {
      return modalManager.state.visibleMap;
    },
    ...mapState(['isMGTV', 'isNoneCashVer']),
    currentStep() {
      return this.steps[this.currentStepIndex]
    },
    isLastStep() {
      return this.currentStepIndex === this.steps.length - 1
    },
  },
  watch: {
    currentStep: 'updateHighlight',
    'visibleMap.c': 'startGuide',
  },
  created() {
    if (!localStorage.getItem('credits_guide') && this.isMGTV && !this.isNoneCashVer) {
      modalManager.add('c');
      localStorage.setItem('credits_guide', true)
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateHighlight)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateHighlight)
  },
  methods: {
    startGuide() {
      if (modalManager.state.visibleMap.c) {
        this.currentStepIndex = 0
        this.updateHighlight()

        MgStat.send(
          'cv',
          {},
          {
            mod: 'c_scorenewguidepop',
          }
        )
      }
    },
    updateHighlight() {
      if (!this.currentStep) return
      const targetElement = document.querySelector(this.currentStep.selector)
      if (targetElement) {
        const rect = targetElement.getBoundingClientRect()
        const windowScrollTop = window.scrollY
        const windowScrollLeft = window.scrollX

        // 高亮模块样式
        this.highlightStyle = {
          position: 'absolute',
          top: `${rect.top + windowScrollTop}px`,
          left: `${rect.left + windowScrollLeft}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
          zIndex: 10002,
        }
        let textTop = `${rect.top - 164 + windowScrollTop}px`
        if (this.currentStepIndex === 1) {
          textTop = `${rect.top - 84 + windowScrollTop}px`
        }
        // 文本指引样式
        this.textStyle = {
          position: 'absolute',
          top: textTop,
          //   left: `${rect.left + windowScrollLeft}px`,
          zIndex: 10003,
        }

        this.buttonStyle = {
          position: 'absolute',
          top: `${rect.top - 60 + windowScrollTop}px`,
          zIndex: 10003,
        }

        // 复制目标元素
        this.cloneTargetElement(targetElement)
      }
    },
    cloneTargetElement(targetElement) {
      const cloneContainer = this.$refs.cloneContainer
      if (cloneContainer) {
        // 清空上一次的内容
        cloneContainer.innerHTML = ''

        // 复制目标元素
        const clone = targetElement.cloneNode(true)
        clone.style.margin = '0' // 清除可能的外边距干扰
        clone.style.pointerEvents = 'none' // 防止交互
        cloneContainer.appendChild(clone)
      }
    },
    nextStep() {
      if (this.isLastStep) {
        this.finishGuide()
      } else {
        this.currentStepIndex += 1
      }
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_newHome',
          mod: 'new_guide',
          cont: '新手引导',
        }
      )
    },
    finishGuide() {
      modalManager.close('c')
      this.$emit('finish')
    },
  },
}
</script>

<style lang="less" scoped>
.guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
}

.highlight-clone {
  position: absolute;
  z-index: 10001;
}

.transparent-layer {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.01); /* 防止透传点击 */
  z-index: 10002;
  cursor: pointer;
}

.guide-text {
  pointer-events: auto;
  width: 100%;
}

button {
  position: absolute;
  width: 174px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 24px 24px 24px 24px;
  border: 2px dashed #ffffff;
  left: 50%;
  top: 144px;
  margin-left: -87px;
  font-weight: 500;
  font-size: 26px;
  color: #ffffff;
}
.step1-tips {
  position: relative;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    width: 671px;
    height: 297px;
  }
}
.step2-tips {
  width: 100%;
  text-align: center;
  img {
    width: 636px;
    height: 142px;
  }
  button {
    top: 560px;
  }
}
</style>
